export const BRAND_ASSETS = {
  // Promotional giveaway image (uploaded by client)
  hero: "https://customer-assets.emergentagent.com/job_natural-giveaway/artifacts/7n63g7p4_ChatGPT%20Image%20Apr%2024%2C%202026%2C%2008_23_56%20AM.png",
  logo_banner:
    "https://thenatural.com/cdn/shop/files/llama_na.png?v=1776438841&width=1400",
  sample_product:
    "https://thenatural.com/cdn/shop/files/digest-a-meal-for-web.png?v=1727540994&width=460",
  // The Natural logomark (uploaded by client)
  site_logo:
    "https://customer-assets.emergentagent.com/job_natural-giveaway/artifacts/oukndxjd_Untitled-1_Recovered%20%282%29.avif",
  // Real Young Again Creatine product (uploaded by client; same asset served from thenatural.com CDN)
  creatine_jar:
    "https://customer-assets.emergentagent.com/job_natural-giveaway/artifacts/ok9tb743_9_658d58f4-6a9d-42f0-b688-67961798a9fd.webp",
};

export const BRANDS = [
  {
    name: "Young Again",
    url: "https://thenatural.com/cdn/shop/files/Young_Again.jpg?v=1729944452&width=700",
  },
  {
    name: "Nordic Naturals",
    url: "https://thenatural.com/cdn/shop/files/Nordic_Naturals.jpg?v=1729944567&width=700",
  },
  {
    name: "Pure Encapsulations",
    url: "https://thenatural.com/cdn/shop/files/Pure_Encapsilations.jpg?v=1729944742&width=700",
  },
  {
    name: "Garden of Life",
    url: "https://thenatural.com/cdn/shop/files/Garden_of_Life.jpg?v=1729944828&width=700",
  },
  {
    name: "Optimal Health System",
    url: "https://thenatural.com/cdn/shop/files/Optimal_Health_System.jpg?v=1729944928&width=700",
  },
  {
    name: "Metagenics",
    url: "https://thenatural.com/cdn/shop/files/metagenics_logo_rect.png?v=1739914773&width=700",
  },
  {
    name: "Momentous",
    url: "https://thenatural.com/cdn/shop/files/Momentous.jpg?v=1729945089&width=700",
  },
  {
    name: "Llama Naturals",
    url: "https://thenatural.com/cdn/shop/files/llama_na.png?v=1776438841&width=1400",
  },
];

// Full shop-by-brand directory (A–Z) from thenatural.com/pages/brands
export const ALL_BRANDS = [
  "Allergy Research Group",
  "American Bio-Science",
  "American Biotech Labs",
  "Arthur Andrew Medical",
  "Ascent Nutrition",
  "Aura Cacia",
  "Ayush Herbs",
  "Babo Botanicals",
  "Badger",
  "Bellawell Health",
  "Bethany's Pantry",
  "Bezwecken",
  "Bioclinic Naturals",
  "Biogenesis Nutraceuticals",
  "Boericke And Tafel",
  "Buried Treasure",
  "Cardiovascular Research",
  "Carlson",
  "Core Med Science",
  "Country Life",
  "Davinci",
  "Daiwa Health Development",
  "Desert Essence",
  "Designs for Health",
  "Deva Nutrition",
  "Deva Vegan Vitamins",
  "Douglas Laboratories",
  "Dr. Hauschka",
  "Dr. Robert Love's Supplements",
  "Dr. Nenninger",
  "Earth Science",
  "Ecological Formulas",
  "Emerita",
  "Enzyme Science",
  "Enzymedica",
  "Essential Formulas",
  "EuroMedica Inc",
  "F'ing Focus",
  "Forces Of Nature",
  "Gaia Herbs",
  "Garden of Life",
  "Genestra",
  "Giovanni",
  "Health Concerns",
  "Herb Pharm",
  "Healthy Day Supplements",
  "Herbal Roots",
  "Heritage",
  "IBDassist",
  "Innate Response Formulas",
  "Integrative Therapeutics",
  "Inter Plexus",
  "Jarrow",
  "Karuna",
  "Karuna Corporation",
  "Klaire Labs",
  "Klean Athlete",
  "Lidtke Technologies",
  "Life Extension",
  "Llama Naturals",
  "Manuka Health",
  "Megafood",
  "Metagenics",
  "Momentous",
  "Mushroom Wisdom",
  "Natures Way",
  "New Chapter",
  "Nordic Naturals",
  "Nordic Naturals Pro",
  "North American Herb & Spice",
  "Nourished Natural Health",
  "NuMedica",
  "Om Organic Mushroom Nutrition",
  "Optimal Health System",
  "Optimox",
  "Organic India",
  "Ortho Molecular",
  "OWL Venice",
  "Pharmax",
  "Protocol For Life",
  "Pure Encapsulations",
  "Pure Good",
  "Ritual",
  "RX Vitamins Inc",
  "Smarty Pants",
  "Solgar",
  "Sovereign Silver",
  "Sun Chlorella",
  "Terry Naturally",
  "Thorne Research",
  "Troscriptions",
  "Unda",
  "Vinco",
  "Vital Nutrients",
  "Vitanica",
  "VSL#3",
  "Weleda",
  "Young Again",
];

export const TESTIMONIALS = [
  {
    name: "Megan L.",
    quote:
      "I've been using the herbal sleep aid for a month — it's been a game changer. I finally feel rested and refreshed. Love that it's made with natural ingredients.",
    rating: 5,
  },
  {
    name: "John D.",
    quote:
      "The digestive support supplement significantly improved my gut health. Noticed a difference in days. Quality of ingredients is top-notch.",
    rating: 5,
  },
  {
    name: "Emily W.",
    quote:
      "I was skeptical about herbal supplements. After trying the immune booster from The Natural, I'm convinced — more energized and haven't caught a cold all season.",
    rating: 5,
  },
];
